import Naluri from '~/common/api/naluri'
import {
  NOTES_CREATE_NOTE_BEGIN,
  NOTES_CREATE_NOTE_SUCCESS,
  NOTES_CREATE_NOTE_FAILURE,
  NOTES_CREATE_NOTE_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function createNote(channel = {}, params = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: NOTES_CREATE_NOTE_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = Naluri.post(`/api/expert/notes/${channel}`, params)
      doRequest.then(
        (res) => {
          if (res.body) {
            dispatch({
              type: NOTES_CREATE_NOTE_SUCCESS,
              data: res,
            });
          } else {
            dispatch({
              type: NOTES_CREATE_NOTE_FAILURE,
              data: { error: res },
            });
          }

          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: NOTES_CREATE_NOTE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissCreateNoteError() {
  return {
    type: NOTES_CREATE_NOTE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case NOTES_CREATE_NOTE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        createNotePending: true,
        createNoteError: null,
      };

    case NOTES_CREATE_NOTE_SUCCESS:
      // The request is success
      return {
        ...state,
        listings: state.listings.push(action.data),
        createNotePending: false,
        createNoteError: null,
      };

    case NOTES_CREATE_NOTE_FAILURE:
      // The request is failed
      return {
        ...state,
        createNotePending: false,
        createNoteError: action.data.error,
      };

    case NOTES_CREATE_NOTE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        createNoteError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/notes/redux/createNote.js